import api from '../api/client';
import React from 'react';
import { Card, Row, Col, Alert, Tag, Progress, Typography } from 'antd';
import { AlertOutlined, CheckCircleOutlined, InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const FarmInsights = ({ insights, farmData }) => {
    if (!insights) return null;

    const getIrrigationColor = (level) => {
        switch (level) {
            case 'high':
                return '#cf1322';
            case 'medium':
                return '#faad14';
            case 'low':
                return '#52c41a';
            default:
                return '#d9d9d9';
        }
    };

    const getPestRiskColor = (risk) => {
        switch (risk) {
            case 'high':
                return '#cf1322';
            case 'medium':
                return '#faad14';
            case 'low':
                return '#52c41a';
            default:
                return '#d9d9d9';
        }
    };

    return (
        <Card title="Farm Insights & Recommendations" bordered={false}>
            {/* Warnings */}
            {insights.warnings && insights.warnings.length > 0 && (
                <div style={{ marginBottom: '20px' }}>
                    {insights.warnings.map((warning, index) => (
                        <Alert
                            key={index}
                            message={warning}
                            type="warning"
                            showIcon
                            icon={<WarningOutlined />}
                            style={{ marginBottom: '8px' }}
                        />
                    ))}
                </div>
            )}

            <Row gutter={[24, 24]}>
                {/* Irrigation Advice */}
                <Col xs={24} md={12}>
                    <Card size="small" title="Irrigation Advice">
                        <div style={{ textAlign: 'center' }}>
                            <Tag
                                color={getIrrigationColor(insights.irrigationAdvice.level)}
                                style={{ fontSize: '14px', padding: '8px 16px' }}
                            >
                                {insights.irrigationAdvice.level.toUpperCase()}
                            </Tag>
                            <div style={{ marginTop: '12px' }}>
                                <Text>{insights.irrigationAdvice.advice}</Text>
                            </div>
                        </div>
                    </Card>
                </Col>

                {/* Planting Advice */}
                <Col xs={24} md={12}>
                    <Card size="small" title="Planting Conditions">
                        <div style={{ textAlign: 'center' }}>
                            {insights.plantingAdvice.suitable ? (
                                <CheckCircleOutlined style={{ fontSize: '24px', color: '#52c41a' }} />
                            ) : (
                                <AlertOutlined style={{ fontSize: '24px', color: '#cf1322' }} />
                            )}
                            <div style={{ marginTop: '12px' }}>
                                <Text>{insights.plantingAdvice.advice}</Text>
                            </div>
                        </div>
                    </Card>
                </Col>

                {/* Pest Risk */}
                <Col xs={24} md={12}>
                    <Card size="small" title="Pest Risk Assessment">
                        <div style={{ textAlign: 'center' }}>
                            <Tag color={getPestRiskColor(insights.pestRisk.risk)} style={{ fontSize: '14px', padding: '8px 16px' }}>
                                {insights.pestRisk.risk.toUpperCase()} RISK
                            </Tag>
                            <div style={{ marginTop: '12px' }}>
                                <Text>{insights.pestRisk.advice}</Text>
                            </div>
                        </div>
                    </Card>
                </Col>

                {/* Harvest Advice */}
                <Col xs={24} md={12}>
                    <Card size="small" title="Harvest Recommendations">
                        <div style={{ textAlign: 'center' }}>
                            {insights.harvestAdvice.suitable ? (
                                <CheckCircleOutlined style={{ fontSize: '24px', color: '#52c41a' }} />
                            ) : (
                                <InfoCircleOutlined style={{ fontSize: '24px', color: '#faad14' }} />
                            )}
                            <div style={{ marginTop: '12px' }}>
                                <Text>{insights.harvestAdvice.advice}</Text>
                            </div>
                        </div>
                    </Card>
                </Col>

                {/* Growth Stage */}
                <Col xs={24}>
                    <Card size="small" title="Crop Growth Stage">
                        <div style={{ textAlign: 'center' }}>
                            <Title level={4} style={{ margin: '8px 0' }}>
                                {insights.growthStage.stage}
                            </Title>
                            <Progress
                                percent={Math.round(insights.growthStage.progress)}
                                status="active"
                                style={{ maxWidth: '300px', margin: '0 auto' }}
                            />
                            <Text type="secondary" style={{ marginTop: '8px', display: 'block' }}>
                                Progress: {Math.round(insights.growthStage.progress)}%
                            </Text>
                        </div>
                    </Card>
                </Col>
            </Row>
        </Card>
    );
};

export default FarmInsights;
